import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Typography } from '@mui/material';
import './Home.css'
import Main from './Main';
import { Helmet } from 'react-helmet';

const Home = () => {
  const image = 'https://img.freepik.com/free-photo/learn-german-language-online-education-concept_53876-133891.jpg?ga=GA1.2.1573239338.1716897012&semt=ais_hybrid';
  return (
    <Container fluid className="p-5 bg-light" id='Home' >
      <Helmet>
        <title>Holy Institute - Learn German</title>
        <meta name="description" content="Learn German with Holy Institute. We offer a range of courses including A1, A2, B1, and B2 to help you master the German language." />
        <meta name="keywords" content="German courses, learn German, Holy Institute, A1 German, A2 German, B1 German, B2 German" />
      </Helmet>
      <Row className="align-items-center mb-4">
        <Col md={6}>
          <Typography variant="h3" className='texthead fonts ' style={{fontFamily: 'Roboto Slab, serif'}} gutterBottom>
            Why Learn German?
          </Typography>
          <Typography variant="h5" style={{fontFamily: 'Roboto Slab, serif'}} className='texthead' gutterBottom>
            Unlock New Opportunities with the German Language
          </Typography>
          <Typography variant="body1" style={{fontFamily: 'Roboto Slab, serif'}} paragraph>
            Learning German opens a world of possibilities, whether you're interested in advancing your career,
            exploring European culture, or enhancing your travel experiences. As one of the most widely spoken
            languages in Europe, German is the key to connecting with over 100 million native speakers and
            accessing a wealth of knowledge in fields like science, engineering, literature, and philosophy.
          </Typography>
        </Col>
        <Col md={6} className="text-center" >
          <img src={image} style={{borderRadius:'5px'}} alt="Why Learn German?" className="img-fluid cardhover" />
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <Typography variant="h6" style={{fontFamily: 'Roboto Slab, serif'}} className='texthead' gutterBottom>
            Career Advancement:
          </Typography>
          <Typography variant="body1" style={{fontFamily: 'Roboto Slab, serif'}} paragraph>
            Germany is one of the world’s leading economies, and fluency in German can give you a competitive
            edge in the global job market. Many multinational companies seek professionals who can bridge the
            gap between cultures and languages.
          </Typography>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <Typography variant="h6" style={{fontFamily: 'Roboto Slab, serif'}} className='texthead' gutterBottom>
            Cultural Enrichment:
          </Typography>
          <Typography variant="body1" style={{fontFamily: 'Roboto Slab, serif'}} paragraph>
            Immerse yourself in the rich cultural heritage of German-speaking countries. From classical music to
            contemporary art, literature, and film, understanding German allows you to appreciate these contributions in their original form.
          </Typography>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <Typography variant="h6" style={{fontFamily: 'Roboto Slab, serif'}} className='texthead' gutterBottom>
            Travel and Communication:
          </Typography>
          <Typography variant="body1" style={{fontFamily: 'Roboto Slab, serif'}} paragraph>
            Whether you're traveling through Germany, Austria, Switzerland, or other parts of Europe, knowing German
            will enhance your travel experience, making it easier to communicate, navigate, and connect with locals.
          </Typography>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <Typography variant="h6" style={{fontFamily: 'Roboto Slab, serif'}} className='texthead' gutterBottom>
            Academic and Research Excellence:
          </Typography>
          <Typography variant="body1" style={{fontFamily: 'Roboto Slab, serif'}} paragraph>
            German is the second most commonly used language in scientific research. Learning German provides access to
            a vast array of academic resources, making it an essential skill for students and researchers.
          </Typography>
        </Col>
      </Row>

      <Row>
        <Col>
        <span className='texthead' style={{fontFamily: 'Roboto Slab, serif',fontSize:'10px'}}>
          By choosing Holy Institute, you're not just enrolling in a language course—you’re joining
          a community dedicated to your growth and success.
          </span>
        </Col>
      </Row>
      <div style={{width:'100%'}} className='my-2 mx-0 p-0 border border'> </div>
      <Main/>
    </Container>
  );
};

export default Home;
